class RangeSliderControl {
  constructor(minId, maxId, minDifference, min, max) {
    this.fromSlider = document.querySelector(`#${minId}-slider`);
    this.toSlider = document.querySelector(`#${maxId}-slider`);
    this.fromInput = document.querySelector(`#${minId}`);
    this.toInput = document.querySelector(`#${maxId}`);
    this.minDifference = minDifference;
    this.min = min;
    this.max = max;
    this.toInputContainer = document.querySelectorAll('.input-container');

    this.setupEventListeners();
    this.fillSlider(this.fromInput, this.toInput, this.toSlider);
  }

  getParsed(currentFrom, currentTo) {
    const from = parseInt(currentFrom.value, 10);
    const to = parseInt(currentTo.value, 10);
    return [from, to];
  }

  fillSlider(from, to, controlSlider) {
    const inactiveColor = 'rgb(var(--color-grey-300) / var(--tw-bg-opacity))';
    const activeColor = 'rgb(var(--color-primary-main) / var(--tw-bg-opacity))';
    const rangeDistance = to.max - to.min;
    const fromPosition = from.value - to.min;
    const toPosition = to.value - to.min;
    controlSlider.style.background = `linear-gradient(
    to right,
    ${inactiveColor} 0%,
    ${inactiveColor} ${(fromPosition / rangeDistance) * 100}%,
    ${activeColor} ${(fromPosition / rangeDistance) * 100}%,
    ${activeColor} ${(toPosition / rangeDistance) * 100}%,
    ${inactiveColor} ${(toPosition / rangeDistance) * 100}%,
    ${inactiveColor} 100%)`;
  }

  setInputWidth(input) {
    input.style.width = `${input.value.length + 1}ch`;
  }

  controlFromInput() {
    const [from, to] = this.getParsed(this.fromInput, this.toInput);
    if (!!!from || from < this.min) {
      this.fromSlider.value = this.min;
      this.fromInput.value = this.min;
    } else if (from >= this.max - this.minDifference) {
      this.fromSlider.value = this.max - this.minDifference;
      this.fromInput.value = this.max - this.minDifference;
      this.toSlider.value = this.max;
      this.toInput.value = this.max;
    } else if (from > to - this.minDifference) {
      this.fromSlider.value = from;
      this.toSlider.value = from + this.minDifference;
      this.toInput.value = from + this.minDifference;
    } else {
      this.fromSlider.value = from;
    }
    this.fillSlider(this.fromInput, this.toInput, this.toSlider);
    this.setInputWidth(this.fromInput);
  }

  controlToInput() {
    const [from, to] = this.getParsed(this.fromInput, this.toInput);
    if (to < this.min + this.minDifference) {
      this.toSlider.value = this.min + this.minDifference;
      this.toInput.value = this.min + this.minDifference;
      this.fromSlider.value = this.min;
      this.fromInput.value = this.min;
    } else if (to < from + this.minDifference) {
      this.toSlider.value = to;
      this.fromSlider.value = to - this.minDifference;
      this.fromInput.value = to - this.minDifference;
    } else if (to >= this.max || !!!to) {
      this.toSlider.value = this.max;
      this.toInput.value = this.max;
      this.toInput.parentNode.classList.remove('after:hidden');
    } else {
      this.toSlider.value = to;
    }
    this.fillSlider(this.fromInput, this.toInput, this.toSlider);
    this.setInputWidth(this.toInput);
  }

  controlFromSlider() {
    const [from, to] = this.getParsed(this.fromSlider, this.toSlider);
    if (from + this.minDifference > to) {
      this.fromSlider.value = to - this.minDifference;
      this.fromInput.value = to - this.minDifference;
    } else {
      this.fromInput.value = from;
      this.fillSlider(this.fromSlider, this.toSlider, this.toSlider);
    }
    this.setInputWidth(this.fromInput);
  }

  controlToSlider() {
    const [from, to] = this.getParsed(this.fromSlider, this.toSlider);
    if (from + this.minDifference <= to) {
      this.toSlider.value = to;
      this.toInput.value = to;
      this.fillSlider(this.fromSlider, this.toSlider, this.toSlider);
    } else {
      this.toInput.value = from + this.minDifference;
      this.toSlider.value = from + this.minDifference;
    }
    if (to == this.max) {
      this.toInput.parentNode.classList.remove('after:hidden');
    } else {
      this.toInput.parentNode.classList.add('after:hidden');
    }
    this.setInputWidth(this.toInput);
  }

  setupEventListeners() {
    this.fromSlider.addEventListener('input', () => this.controlFromSlider());
    this.toSlider.addEventListener('input', () => this.controlToSlider());
    this.fromInput.addEventListener('blur', () => this.controlFromInput());
    this.toInput.addEventListener('blur', () => this.controlToInput());
    this.toInput.addEventListener('input', () => {
      this.setInputWidth(this.toInput);
      this.toInput.parentNode.classList.add('after:hidden');
    });
    this.fromInput.addEventListener('input', () => this.setInputWidth(this.fromInput));
    this.toInputContainer.forEach((container) => {
      container.addEventListener('click', () => container.querySelector('input').focus());
    });
  }
}

class MultiSelect {
  constructor(value, id, placeholder, componentName) {
    this.value = value;
    this.id = id;
    this.placeholder = placeholder;
    this.componentName = componentName;
    this.initialize();
  }

  initialize() {
    const brandInput = document.querySelector(`#brand-input-${this.id}`);
    const dropdown = document.querySelector(`#${this.id}`);
    
    brandInput.addEventListener('input', (e) => this.handleBrandInput(e));
    document.querySelectorAll(`input[name="${this.id}"]`).forEach((el) => {
      el.addEventListener('change', () => this.updateChips());
    });
 
    document.addEventListener('click', (e) => this.handleDocumentEvent(e, dropdown, 'click'));
    document.addEventListener('focusin', (e) => this.handleDocumentEvent(e, dropdown, 'focusin'));
    document.addEventListener('click', (e) => this.handleUncheckClick(e));

    document.querySelectorAll(`input[name="${this.id}"]`).forEach((el) => {
      el.addEventListener('change', () => this.updateChips());
    });
  }

  handleBrandInput(e) {
    const value = e.target.value.toLowerCase();
    const options = document.querySelectorAll(`#${this.id} label`);

    options.forEach((option) => {
      const parentParentNode = option.parentNode;
      parentParentNode.classList.toggle('!hidden', !option.textContent.toLowerCase().includes(value));
    });
  }

  handleDocumentEvent(e, dropdown, eventType) {  
    if (eventType === 'click' && e.target.closest(`#${this.id}`) === null) {
      dropdown.removeAttribute('open');
    }
  }

  handleUncheckClick(e) {
    const uncheckDataAttribute = `data-${this.componentName.toLowerCase()}-uncheck`;

    if (e.target.matches(`[${uncheckDataAttribute}]`)) {
      const value = e.target.closest(`[${uncheckDataAttribute}]`).getAttribute(`${uncheckDataAttribute}`);
      this.uncheckAndRefresh(value);
    }
  }

  updateChips() {
    const brandText = document.querySelector(`details#${this.id} summary #brand-text`);
    const checked = Array.from(document.querySelectorAll(`input[name="${this.id}"]:checked`));

    if (checked.length === 0) {
      brandText.innerHTML = this.placeholder;
      return;
    }

    const checkedText = checked.slice(0, 3).map((el) => this.getChipHTML(el.parentNode.querySelector(`label`).textContent, el.id));

    if (checked.length > 3) {
      checkedText.push(this.getChipHTML(`+${checked.length - 3} more`));
    }

    brandText.innerHTML = checkedText.join('');

  }

  getChipHTML(label, id) {
    return `<span class="inline-flex items-center gap-1 rounded-full px-1.5 py-0.5 bg-black text-white">${label}<button data-${this.componentName.toLowerCase()}-uncheck="${id}"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-2.5 h-2.5 pointer-events-none"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" /></svg></button></span>`;
  }

  uncheckAndRefresh(value) {
    document.getElementById(value).checked = false;
    this.updateChips();
  }
}